import { render } from "./AreaChartStacked.vue?vue&type=template&id=3c974291"
import script from "./AreaChartStacked.vue?vue&type=script&lang=js"
export * from "./AreaChartStacked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__